module.exports = __webpack_public_path__ + "static/media/map1.4ad51ef5.png";